import { Heading, HeadingProps } from '@chakra-ui/react'
import React from 'react'

export default function SharedSectionHeader({
    children,
    ...props
}: HeadingProps) {
    return (
        <Heading size="sm" fontWeight="semibold" color="navy.700" {...props}>
            {children}
        </Heading>
    )
}
